import React from 'react';
import TablaSolicitudDivisionTerrenos from './Tablas/TablaSolicitudDivisionTerrenos';
import GraficoSolicitudDivisionTerrenos from './Graficos/GraficoSolicitudDivisionTerrenos';
import { VStack, Heading } from '@chakra-ui/react';
import ObrasDivisionTerrenosDashboard from './Dashboard/ObrasDivisionTerrenosDashboard';

const ObrasDivisionTerrenos: React.FC = () => {
  return (
    <VStack spacing={8} align="stretch">
      <Heading size="lg" textAlign="center" color="blue.700">
        DivisionTerrenos
      </Heading>
      <ObrasDivisionTerrenosDashboard/>
      <TablaSolicitudDivisionTerrenos />
      {/* <GraficoSolicitudDivisionTerrenos /> */}
    </VStack>
  );
};

export default ObrasDivisionTerrenos;
